import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const userRoleDelete = createAsyncThunk("userRoleDelete", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.delete(
      `${API_KEY}/api/user/delete-role-flat`,
      {
        data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        "Content-Type": "application/json",
      }
    );
    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  userRoleDeleteData: null,
  isError: false,
  errorMessage: "",
};

const userRoleDeleteSlice = createSlice({
  name: "userRoleDelete",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userRoleDelete.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userRoleDelete.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userRoleDeleteData = action.payload;
    });
    builder.addCase(userRoleDelete.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default userRoleDeleteSlice.reducer;
